/**
 * EditProfile Component
 *
 * Redirect stub that sends users from the legacy /edit-profile route
 * to the current /profile page. Profile editing is now handled inline
 * on the main profile page rather than on a separate route.
 *
 * Uses React Router's <Navigate> with `replace` so the stale URL does
 * not remain in the browser history.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';

export default function EditProfile() {
    return <Navigate to="/profile" replace />;
}
